export default __webpack_public_path__ + "static/media/ic_globe_48px.c26363ea.svg";